const actionTypeIdentifier = 'F9CC1C8A-5294-46B9-9672-22B2959D597A';

export const getInventoryOrderHistory = `GET-INVENTORY-ORDER-HISTORY${actionTypeIdentifier}`;
export const setInventoryOrderHistoryError = `SET-INVENTORY-ORDER-HISTORY-ERROR-${actionTypeIdentifier}`;
export const setInventoryOrderHistoryColSearchStr = `SET-INVENTORY-ORDER-HISTORY-COL-SEARCH-STRING-${actionTypeIdentifier}`;
export const setInventoryOrderHistoryPageSize = `SET-INVENTORY-ORDER-HISTORY-PAGESIZE-${actionTypeIdentifier}`;
export const resetInventoryOrderHistory = `RESET-INVENTORY-ORDER-HISTORY-${actionTypeIdentifier}`;